import React, { useEffect, useState } from "react";
import AnnouncementCard from "./announcement-card";
import "../host.css";
import { REACT_APP_API_BASE_URL } from "../../../../env";

const API_BASE_URL = REACT_APP_API_BASE_URL;

const Announcements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAnnouncements = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(`${API_BASE_URL}/announcements`);
        if (!res.ok) throw new Error("Failed to fetch announcements");
        const data = await res.json();
        setAnnouncements(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchAnnouncements();
  }, []);

  return (
    <div className="container-fluid announcements-full-height">
      <div className="announcements-container">
        {loading && <div>Loading...</div>}
        {error && <div className="text-danger">{error}</div>}
        {!loading && !error && announcements.length === 0 && (
          <div>No announcements found.</div>
        )}
        {announcements.map((announcement, index) => (
          <React.Fragment key={announcement._id}>
            <AnnouncementCard announcement={announcement} />
            {index < announcements.length - 1 && (
              <hr className="announcement-divider" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Announcements;
